var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEscenarios({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.895,
    height: 15.947,
    viewBox: "0 0 10.895 15.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Escenarios",
    transform: "translate(-24.156 -17.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7780",
    "data-name": "Path 7780",
    className: "cls-1",
    d: "M34.389,17.941H24.814a.658.658,0,0,0-.658.658V33.888h3.022V29.825A1.317,1.317,0,0,1,28.5,28.508h2.212a1.317,1.317,0,0,1,1.317,1.317v4.063h3.022V18.6a.658.658,0,0,0-.658-.658Zm-6.1,8.181h-1.5a.658.658,0,1,1,0-1.317h1.5a.658.658,0,0,1,0,1.317Zm0-2.444h-1.5a.658.658,0,1,1,0-1.317h1.5a.658.658,0,1,1,0,1.317Zm0-2.444h-1.5a.658.658,0,1,1,0-1.317h1.5a.658.658,0,0,1,0,1.317Zm4.129,4.887h-1.5a.658.658,0,1,1,0-1.317h1.495a.658.658,0,1,1,0,1.317Zm0-2.444h-1.5a.658.658,0,1,1,0-1.317h1.495a.658.658,0,1,1,0,1.317Zm0-2.444h-1.5a.658.658,0,1,1,0-1.317h1.495a.658.658,0,1,1,0,1.317Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscenarios);
export default __webpack_public_path__ + "static/media/Escenarios.8ce72214ef32eada79199f91a1ca7ac2.svg";
export { ForwardRef as ReactComponent };